import { APP_INITIALIZER } from '@angular/core';
import { ConfigService } from './config.service';

export const ConfigFactory = (config: ConfigService) => () => config.load();

export const init = () => ({
        provide: APP_INITIALIZER,
        useFactory: ConfigFactory,
        deps: [ConfigService],
        multi: true
    });

export const ConfigInitializer = {
    init
};
